<template>
  <div
    :class="{ expanded: $parent.expanded }"
    class="side-bar position-fixed">
    <ul class="list-unstyled list-addStyle text-center">
      <li
        :class="{ selected: participant }"
        class="cursor"
        @click="toggleBar('participants')">
        <account-multiple-icon
          :size="20"
        />
        <b-badge
          v-if="$parent.numberOfPeople > 0 "
          class="count-badge"
          variant="outline">{{ $parent.numberOfPeople }}</b-badge>
      </li>
      <li
        :class="{ selected: chat }"
        class="cursor"
        @click="toggleBar('chat')">
        <message-icon
          :size="20"
        />
        <b-badge
          v-if="$parent.newChat > 0 "
          class="count-badge"
          variant="danger"><b>{{ $parent.newChat }}</b></b-badge>
      </li>
      <li
        v-if="$parent.newSystemMessage > 0 "
        :class="{ selected: system }"
        class="cursor system"
        @click="toggleBar('system')">
        <alert-icon
          :size="20"
        />
      </li>
    </ul>
    <div class="side-container">
      <system-side
        ref="sideSystem"
        :v-show="system"/>
      <chat-side
        ref="sideChat"
        :v-show="chat"/>
      <participants
        ref="sidePart"
        :v-show="participant"
      />
    </div>
  </div>
</template>
<script>
    import AccountMultipleIcon from "icons/AccountMultiple"
    import MessageIcon from "icons/Message"
    import AlertIcon from "icons/Alert"
    import BookmarkMultipleIcon from "icons/BookmarkMultiple"
    import {ref, watch} from "@vue/composition-api";
    import ChatSide from './ChatSideBar'
    import SystemSide from './SystemSideBar'
    import Participants from "./Participants";

    export default {
       name: 'SideBar',
        components: {
          Participants,
          AccountMultipleIcon,
          MessageIcon,
          AlertIcon,
          BookmarkMultipleIcon,
          ChatSide,
          SystemSide,

        },
        setup(props, context) {
          const chat = ref(false)
          const system = ref(false)
          const participant = ref(false)
          var lastTab = null;
          // This code is getting smelly
          function toggleBar(tab){
              switch (tab) {
                case 'chat':
                  chat.value = !chat.value
                  system.value = false;
                  participant.value = false;
                  break;
                case 'system':
                  system.value = !system.value
                  chat.value = false;
                  participant.value = false;
                  break;
                case 'participants':
                  participant.value = !participant.value
                  chat.value = false;
                  system.value = false;
                  break;
              }

              context.parent.expanded = !context.parent.expanded || tab !== lastTab
              lastTab = tab;
            }

          watch(chat, (value, oldValue) => {
            if (oldValue != undefined) {
              if (value) {
                context.parent.newChat = 0
                context.refs.sideChat.$refs.chatArea.scrollTop = context.refs.sideChat.$refs.chatArea.scrollHeight
                if (context.parent.plenary) {
                  context.refs.sideChat.getModerators()
                }
              }
            }
          })
           return {
             toggleBar,
             chat,
             system,
             participant,
           }
        },
    }
</script>
<style scoped>
.system{
  position: absolute!important;
  width: 48px;
  bottom: 5px;
}
.expanded {
  width: 100% !important;
}
@media (min-width: 768px) {
.expanded{
  width: 370px !important;

}
}

</style>



// WEBPACK FOOTER //
// src/components/SideBar.vue